import { extractData } from '../../utils/response';

const SECTION_TITLES = {
  primary: 'Status Overview',
  secondary: 'Additional Metrics',
};

function normalizeCardItem(item, index) {
  const label = item?.label ?? item?.status_name ?? item?.status ?? '—';
  const statusName = String(
    item?.status_name ?? item?.status ?? item?.label ?? ''
  ).trim();
  // Dashboard API provides status_uuid — use that as leads list status_id
  const statusId =
    item?.status_uuid ?? item?.status_id ?? item?.statusId ?? item?.uuid ?? null;
  const id =
    statusId != null && statusId !== ''
      ? String(statusId)
      : statusName || String(index);

  return {
    id,
    label,
    status: statusName,
    statusName,
    statusId: statusId != null && statusId !== '' ? String(statusId) : '',
    count: item?.count ?? 0,
  };
}

function formatSectionTitle(key) {
  if (SECTION_TITLES[key]) return SECTION_TITLES[key];
  return String(key || 'overview')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

/** Parse GET /dashboards role-based payload into renderable sections */
export function parseDashboardOverview(response) {
  const raw = extractData(response);
  const body =
    raw?.data && typeof raw.data === 'object' && !Array.isArray(raw.data)
      ? raw.data
      : raw;

  if (!body || typeof body !== 'object' || Array.isArray(body)) {
    return { role: '', sections: [] };
  }

  const role = body.role ?? '';
  const sections = [];

  Object.entries(body).forEach(([key, value]) => {
    if (key === 'role' || !Array.isArray(value)) return;
    sections.push({
      key,
      title: formatSectionTitle(key),
      items: value.map(normalizeCardItem),
    });
  });

  return { role, sections };
}
